import {
  LitElement,
  html,
  css,
} from '@hh/global.js'

class HHHeaderSubmenuTrigger extends LitElement {

  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
    for: {
      type: String
    }
  }

  constructor() {
    super()
    this.for = false;
  }

  connectedCallback() {
    super.connectedCallback()
  }

  toggle() {
    this.open = !this.open
    if (this.for) {
      this.dispatchEvent(new CustomEvent('mobile-menu:page', {
        bubbles: true,
        composed: true,
        detail: {
          for: this.for,
          open: this.open
        },
      }))
    }
  }

  static styles = css`
    .mobile-menu__submenu {
      display: flex;
      flex-direction: column;
      border-bottom: 0.1rem solid var(--hh-color-brand-secondary);
    }

    .mobile-menu__submenu .title {
      padding: 2rem 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      font-size: 1.4rem;
      text-transform: uppercase;
    }

    .head {
      color: currentColor;
      background: none;
      font: inherit;
      text-align: left;
      padding: 0;
      border: none;
      margin: 0;
      cursor: pointer;
    }
  `

  render() {
    return html`
      <div class="mobile-menu__submenu" aria-expanded="${this.open}">
        <button type="button" class="head" @click=${this.toggle}>
          <span class="title">
            <slot name="title"></slot>
            <slot name="icon"></slot>
          </span>
        </button>
      </div>
    `
  }
}
customElements.define('hh-header-submenu-trigger', HHHeaderSubmenuTrigger)

class HHHeaderSubmenu extends LitElement {

  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
    trigger: {
      type: String
    }
  }

  constructor() {
    super()
    this.closeButtonEl = this.querySelector('[data-submenu-close]')
    document.addEventListener('mobile-menu:page', this.triggerHandler.bind(this))
  }

  triggerHandler(e) {
    if (e.detail.for == this.trigger) {
      this.toggle()
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.closeButtonEl?.addEventListener('click', this.closeSubmenu.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener('mobile-menu:page', this.triggerHandler)
  }


  closeSubmenu(e) {
    e.preventDefault()
    this.toggle()
  }

  toggle() {
    this.parentNode.toggleAttribute('mobile-menu-page')
    this.open = !this.open
  }

  render() {
    return html`
      <div class="mobile-menu__submenu--content" aria-expanded="${this.open}">
        <div class="container">
            <slot class="header" name="header"></slot>
            <slot class="body" name="body"></slot>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    ::host {
      postion: relative;
      display: block;
      height: 100%;
      overflow: hidden;
    }

    .mobile-menu__submenu--content {
      position: fixed;
      left: 0;
      bottom: 0;
      background: var(--background-color);
      width: 100%;
      opacity: 0;
      visibility: hidden;
      transform: translateX(100%);
      transition: transform var(--hh-duration-medium) ease,
      opacity var(--hh-duration-medium) ease,
      visibility var(--hh-duration-medium) ease;
      z-index: 400;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    :host([open]) .mobile-menu__submenu--content {
      position: relative;
      left: unset;
      right: unset;
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
      height: calc(100dvh - var(--header-search-height));
    }

    .container {
      display: flex;
      flex-direction: column;
      height: auto;
      position: relative;
    }

    .footer {
      height: auto;
      position: sticky;
      bottom: 0;
      width: 100%;
      z-index: 2;
      background-color: var(--hh-color-reverse);
    }
  `
}
customElements.define('hh-header-submenu', HHHeaderSubmenu)

